"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setModalName = void 0;
var setModalName = exports.setModalName = function setModalName(modalName) {
  return function (ModalComponent) {
    /* eslint-disable no-param-reassign */
    ModalComponent.modalName = modalName;
    return ModalComponent;
  };
};
//# sourceMappingURL=modals.js.map